import { gql, useMutation } from '@apollo/client';
import { SmsSenderMutationActionResult } from '../types';

/**
 * delete sms sender
 *
 * @param id sms sender id
 * @param replaceId replacement sms sender id (optional)
 */
const deleteSmsSenderMutation = gql`
  mutation DeleteSmsSender($id: Long!, $replaceId: Long) {
    deleteSmsSender(id: $id, replaceId: $replaceId) {
      success
      failure {
        message
      }
    }
  }
`;

type UseDeleteSmsSenderProps = {
  onCompleted: ({ deleteSmsSender }: { deleteSmsSender: SmsSenderMutationActionResult }) => void;
  onError: ({ message }: { message: string }) => void;
};

export const useDeleteSmsSender = ({ onCompleted, onError }: UseDeleteSmsSenderProps) => {
  const [deleteSmsSender, { data, loading, error }] = useMutation(deleteSmsSenderMutation, {
    onCompleted: (response) => {
      const { failure = [], success } = response.deleteSmsSender;

      if (success) {
        return onCompleted(response);
      }

      const errorMessage = failure.map(({ message }: { message: string }) => message).join('. ');
      return onError({ message: errorMessage });
    },
    onError,
  });

  return {
    deleteSmsSender,
    data,
    loading,
    error,
  };
};
